import { INJECT_TAG } from '../constants/metadata_keys';
import { injectBase } from './inject_base';

export const inject = injectBase(INJECT_TAG);
